export const countryIsoCodes = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'OO',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'XK',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
] as const;

const _countryAlpha3Codes = [
  'AND',
  'ARE',
  'AFG',
  'ATG',
  'AIA',
  'ALB',
  'ARM',
  'AGO',
  'ATA',
  'ARG',
  'ASM',
  'AUT',
  'AUS',
  'ABW',
  'ALA',
  'AZE',
  'BIH',
  'BRB',
  'BGD',
  'BEL',
  'BFA',
  'BGR',
  'BHR',
  'BDI',
  'BEN',
  'BLM',
  'BMU',
  'BRN',
  'BOL',
  'BRA',
  'BHS',
  'BTN',
  'BVT',
  'BWA',
  'BLR',
  'BLZ',
  'CAN',
  'CCK',
  'COD',
  'CAF',
  'COG',
  'CHE',
  'CIV',
  'COK',
  'CHL',
  'CMR',
  'CHN',
  'COL',
  'CRI',
  'CUB',
  'CPV',
  'CUW',
  'CXR',
  'CYP',
  'CZE',
  'DEU',
  'DJI',
  'DNK',
  'DMA',
  'DOM',
  'DZA',
  'ECU',
  'EST',
  'EGY',
  'ESH',
  'ERI',
  'ESP',
  'ETH',
  'FIN',
  'FJI',
  'FLK',
  'FSM',
  'FRO',
  'FRA',
  'GAB',
  'GBR',
  'GRD',
  'GEO',
  'GUF',
  'GGY',
  'GHA',
  'GIB',
  'GRL',
  'GMB',
  'GIN',
  'GLP',
  'GNQ',
  'GRC',
  'SGS',
  'GTM',
  'GUM',
  'GNB',
  'GUY',
  'HKG',
  'HMD',
  'HND',
  'HRV',
  'HTI',
  'HUN',
  'IDN',
  'IRL',
  'ISR',
  'IMN',
  'IND',
  'IOT',
  'IRQ',
  'IRN',
  'ISL',
  'ITA',
  'JEY',
  'JAM',
  'JOR',
  'JPN',
  'KEN',
  'KGZ',
  'KHM',
  'KIR',
  'COM',
  'KNA',
  'PRK',
  'KOR',
  'KWT',
  'CYM',
  'KAZ',
  'LAO',
  'LBN',
  'LCA',
  'LIE',
  'OOO',
  'LKA',
  'LBR',
  'LSO',
  'LTU',
  'LUX',
  'LVA',
  'LBY',
  'MAR',
  'MCO',
  'MDA',
  'MNE',
  'MAF',
  'MDG',
  'MHL',
  'MKD',
  'MLI',
  'MMR',
  'MNG',
  'MAC',
  'MNP',
  'MTQ',
  'MRT',
  'MSR',
  'MLT',
  'MUS',
  'MDV',
  'MWI',
  'MEX',
  'MYS',
  'MOZ',
  'NAM',
  'NCL',
  'NER',
  'NFK',
  'NGA',
  'NIC',
  'NLD',
  'NOR',
  'NPL',
  'NRU',
  'NIU',
  'NZL',
  'OMN',
  'PAN',
  'PER',
  'PYF',
  'PNG',
  'PHL',
  'PAK',
  'POL',
  'SPM',
  'PCN',
  'PRI',
  'PSE',
  'PRT',
  'PLW',
  'PRY',
  'QAT',
  'REU',
  'ROU',
  'SRB',
  'RUS',
  'RWA',
  'SAU',
  'SLB',
  'SYC',
  'SDN',
  'SWE',
  'SGP',
  'SHN',
  'SVN',
  'SJM',
  'SVK',
  'SLE',
  'SMR',
  'SEN',
  'SOM',
  'SUR',
  'SSD',
  'STP',
  'SLV',
  'SXM',
  'SYR',
  'SWZ',
  'TCA',
  'TCD',
  'ATF',
  'TGO',
  'THA',
  'TJK',
  'TKL',
  'TLS',
  'TKM',
  'TUN',
  'TON',
  'TUR',
  'TTO',
  'TUV',
  'TWN',
  'TZA',
  'UKR',
  'UGA',
  'USA',
  'URY',
  'UZB',
  'VAT',
  'VCT',
  'VEN',
  'VGB',
  'VIR',
  'VNM',
  'VUT',
  'WLF',
  'WSM',
  'XKX',
  'YEM',
  'MYT',
  'ZAF',
  'ZMB',
  'ZWE',
] as const;

export type CountryAlpha3Code = (typeof _countryAlpha3Codes)[number];

export const countryAlpha2ToAlpha3: Record<CountryIsoCode, CountryAlpha3Code> = {
  AD: 'AND',
  AE: 'ARE',
  AF: 'AFG',
  AG: 'ATG',
  AI: 'AIA',
  AL: 'ALB',
  AM: 'ARM',
  AO: 'AGO',
  AQ: 'ATA',
  AR: 'ARG',
  AS: 'ASM',
  AT: 'AUT',
  AU: 'AUS',
  AW: 'ABW',
  AX: 'ALA',
  AZ: 'AZE',
  BA: 'BIH',
  BB: 'BRB',
  BD: 'BGD',
  BE: 'BEL',
  BF: 'BFA',
  BG: 'BGR',
  BH: 'BHR',
  BI: 'BDI',
  BJ: 'BEN',
  BL: 'BLM',
  BM: 'BMU',
  BN: 'BRN',
  BO: 'BOL',
  BR: 'BRA',
  BS: 'BHS',
  BT: 'BTN',
  BV: 'BVT',
  BW: 'BWA',
  BY: 'BLR',
  BZ: 'BLZ',
  CA: 'CAN',
  CC: 'CCK',
  CD: 'COD',
  CF: 'CAF',
  CG: 'COG',
  CH: 'CHE',
  CI: 'CIV',
  CK: 'COK',
  CL: 'CHL',
  CM: 'CMR',
  CN: 'CHN',
  CO: 'COL',
  CR: 'CRI',
  CU: 'CUB',
  CV: 'CPV',
  CW: 'CUW',
  CX: 'CXR',
  CY: 'CYP',
  CZ: 'CZE',
  DE: 'DEU',
  DJ: 'DJI',
  DK: 'DNK',
  DM: 'DMA',
  DO: 'DOM',
  DZ: 'DZA',
  EC: 'ECU',
  EE: 'EST',
  EG: 'EGY',
  EH: 'ESH',
  ER: 'ERI',
  ES: 'ESP',
  ET: 'ETH',
  FI: 'FIN',
  FJ: 'FJI',
  FK: 'FLK',
  FM: 'FSM',
  FO: 'FRO',
  FR: 'FRA',
  GA: 'GAB',
  GB: 'GBR',
  GD: 'GRD',
  GE: 'GEO',
  GF: 'GUF',
  GG: 'GGY',
  GH: 'GHA',
  GI: 'GIB',
  GL: 'GRL',
  GM: 'GMB',
  GN: 'GIN',
  GP: 'GLP',
  GQ: 'GNQ',
  GR: 'GRC',
  GS: 'SGS',
  GT: 'GTM',
  GU: 'GUM',
  GW: 'GNB',
  GY: 'GUY',
  HK: 'HKG',
  HM: 'HMD',
  HN: 'HND',
  HR: 'HRV',
  HT: 'HTI',
  HU: 'HUN',
  ID: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IM: 'IMN',
  IN: 'IND',
  IO: 'IOT',
  IQ: 'IRQ',
  IR: 'IRN',
  IS: 'ISL',
  IT: 'ITA',
  JE: 'JEY',
  JM: 'JAM',
  JO: 'JOR',
  JP: 'JPN',
  KE: 'KEN',
  KG: 'KGZ',
  KH: 'KHM',
  KI: 'KIR',
  KM: 'COM',
  KN: 'KNA',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KY: 'CYM',
  KZ: 'KAZ',
  LA: 'LAO',
  LB: 'LBN',
  LC: 'LCA',
  LI: 'LIE',
  OO: 'OOO',
  LK: 'LKA',
  LR: 'LBR',
  LS: 'LSO',
  LT: 'LTU',
  LU: 'LUX',
  LV: 'LVA',
  LY: 'LBY',
  MA: 'MAR',
  MC: 'MCO',
  MD: 'MDA',
  ME: 'MNE',
  MF: 'MAF',
  MG: 'MDG',
  MH: 'MHL',
  MK: 'MKD',
  ML: 'MLI',
  MM: 'MMR',
  MN: 'MNG',
  MO: 'MAC',
  MP: 'MNP',
  MQ: 'MTQ',
  MR: 'MRT',
  MS: 'MSR',
  MT: 'MLT',
  MU: 'MUS',
  MV: 'MDV',
  MW: 'MWI',
  MX: 'MEX',
  MY: 'MYS',
  MZ: 'MOZ',
  NA: 'NAM',
  NC: 'NCL',
  NE: 'NER',
  NF: 'NFK',
  NG: 'NGA',
  NI: 'NIC',
  NL: 'NLD',
  NO: 'NOR',
  NP: 'NPL',
  NR: 'NRU',
  NU: 'NIU',
  NZ: 'NZL',
  OM: 'OMN',
  PA: 'PAN',
  PE: 'PER',
  PF: 'PYF',
  PG: 'PNG',
  PH: 'PHL',
  PK: 'PAK',
  PL: 'POL',
  PM: 'SPM',
  PN: 'PCN',
  PR: 'PRI',
  PS: 'PSE',
  PT: 'PRT',
  PW: 'PLW',
  PY: 'PRY',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  RW: 'RWA',
  SA: 'SAU',
  SB: 'SLB',
  SC: 'SYC',
  SD: 'SDN',
  SE: 'SWE',
  SG: 'SGP',
  SH: 'SHN',
  SI: 'SVN',
  SJ: 'SJM',
  SK: 'SVK',
  SL: 'SLE',
  SM: 'SMR',
  SN: 'SEN',
  SO: 'SOM',
  SR: 'SUR',
  SS: 'SSD',
  ST: 'STP',
  SV: 'SLV',
  SX: 'SXM',
  SY: 'SYR',
  SZ: 'SWZ',
  TC: 'TCA',
  TD: 'TCD',
  TF: 'ATF',
  TG: 'TGO',
  TH: 'THA',
  TJ: 'TJK',
  TK: 'TKL',
  TL: 'TLS',
  TM: 'TKM',
  TN: 'TUN',
  TO: 'TON',
  TR: 'TUR',
  TT: 'TTO',
  TV: 'TUV',
  TW: 'TWN',
  TZ: 'TZA',
  UA: 'UKR',
  UG: 'UGA',
  US: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  VA: 'VAT',
  VC: 'VCT',
  VE: 'VEN',
  VG: 'VGB',
  VI: 'VIR',
  VN: 'VNM',
  VU: 'VUT',
  WF: 'WLF',
  WS: 'WSM',
  XK: 'XKX',
  YE: 'YEM',
  YT: 'MYT',
  ZA: 'ZAF',
  ZM: 'ZMB',
  ZW: 'ZWE',
};

export const countriesWithoutTaxFreeZones = countryIsoCodes.filter((c) => c !== 'OO');

export type CountryIsoCode = (typeof countryIsoCodes)[number];

export const intrastatPartnerCountryIsoCodes = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'EL',
  'HR',
  'HU',
  'IE',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
] as const satisfies readonly (CountryIsoCode | 'EL')[];

export const isEuropeanIsoCode = (
  countryCode: string | null | undefined,
): countryCode is (typeof intrastatPartnerCountryIsoCodes)[number] => {
  return Boolean(countryCode && (intrastatPartnerCountryIsoCodes as readonly string[]).includes(countryCode));
};

export interface Country {
  code: CountryIsoCode;
  cca3: CountryAlpha3Code;
  flagCode: string;
  name: string;
}
